export default __webpack_public_path__ + "static/media/hotel_pic.bdfd1901.png";